<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1 class="title_h">Chi tiết doanh số giao dịch MA</h1>
      <div class="btn-group float-right">
        <button
          type="button"
          class="font-medium f12 btn btn-outline-secondary m-r-10"
          @click="$router.push('/customer-support/tpv-ma')"
        >
          <b-icon icon="arrow-left" aria-hidden="true" />
          Quay lại
        </button>
        <DraggableTable :naming="$route.name" v-model="fieldsTable" @change="fields = $event" />
      </div>
    </div>
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="">
          <div class="form-group">
            <Select2
              v-model="filters.maId"
              :options="maOptions"
              :settings="maSettings"
              disabled
              placeholder="Tìm kiếm merchant account"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="filters.managerStaffId" :options="listUser" placeholder="Quản lý" />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.staffId"
              :options="listUser"
              placeholder="Nhân viên chăm sóc"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="filters.serial"
              class="form-control f12 hc-37"
              placeholder="Thiết bị"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.typeTransaction"
              :options="[{ id: '0', text: 'Tất cả' }, ...optionTransactionType]"
              placeholder="Loại giao dịch cấp 1"
              @change="updateTypeOneTransaction"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.subTypeTransaction1"
              :options="[{ id: '0', text: 'Tất cả' }, ...optionSubTypeTransaction1]"
              placeholder="Loại giao dịch cấp 2"
              :disabled="subTypeTransaction1Bool"
              @change="updateTypeTwoTransaction"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.subTypeTransaction2"
              :options="[{ id: '0', text: 'Tất cả' }, ...optionSubTypeTransaction2]"
              placeholder="Loại giao dịch cấp 3"
              :disabled="subTypeTransaction2Bool"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="filters.typeMc"
              :options="[{ id: '0', text: 'Tất cả' }, ...optionTypeMc]"
              placeholder="Nhóm merchant tính KPI"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 11.5em; margin-left: -5px !important"
                  class="text-center"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian giao dịch
                </label>
                <i
                  class="bx bx-calendar fonsize-20"
                  style="position: absolute; right: 1px; top: 50%; transform: translateY(-50%)"
                ></i>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              @click="clearSearch"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="d-flex flex-row">
              <div class="box-header">
                <!-- Tổng công việc:<strong class="text-primary">&nbsp;{{ pagination.total }}</strong> -->
                TPV:<strong class="text-primary">&nbsp;{{ totalTpv | formatNum }}</strong> TPV
                KPI:<strong class="text-success">&nbsp;{{ totalTpvKpi | formatNum }}</strong>
              </div>
            </div>
            <b-table
              hover
              sticky-header
              head-variant="light"
              responsive
              :items="dataTable"
              :fields="fields"
              :fixed="true"
              :bordered="true"
              :busy.sync="isLoading"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #emptyfiltered="{ emptyFilteredText }">
                <h4>{{ emptyFilteredText }}</h4>
              </template>
              <template #cell(index)="{ index }">
                {{
                  pagination.page > 1
                    ? index + 1 + pagination.limit * (pagination.page - 1)
                    : index + 1
                }}
              </template>
              <template #cell(dateTransaction)="{ value }">
                <div>{{ value | formatDate }}</div>
              </template>
              <template #cell(tpv)="{ value }">
                <div class="text-primary">{{ value | formatNum }}</div>
              </template>
              <template #cell(tpvKpi)="{ value }">
                <div class="text-success">{{ value | formatNum }}</div>
              </template>
              <template #cell(typeTransaction)="{ value }">
                <div>{{ getTypeTransaction(value) }}</div>
              </template>
              <template #cell(typeMc)="{ value }">
                <div>
                  <b-badge :variant="getTypeMcVariant(value)">{{ getTypeMc(value) }}</b-badge>
                </div>
              </template>
              <template #cell(serial)="{ value }">
                <div>Serial: {{ value }}</div>
              </template>
              <template #cell(merchant)="{ item }">
                <div>{{ item.merchantName }}</div>
                <div>{{ item.merchantEmail }}</div>
                <div>Nguồn: {{ item.referSource }}</div>
                <!-- <b-badge variant="success" v-if="item.status === 'ACTIVE'">Đang hoạt
                  động</b-badge>
                <b-badge variant="danger" v-else>Ngừng hoạt động</b-badge> -->
              </template>
              <template #cell(sale)="{ item }">
                <div>{{ item.userCare && item.userCare.name ? item.userCare.name : '' }}</div>
                <div>{{ item.userCare && item.userCare.email ? item.userCare.email : '' }}</div>
              </template>
              <template #cell(action)="{ item }">
                <b-button variant="link" @click="viewDetails(item)">Chi tiết</b-button>
              </template>
            </b-table>
            <div class="d-flex justify-content-end">
              <b-form-group class="mb-0" style="padding: 17px">
                <b-form-select
                  v-model="pagination.limit"
                  :options="pageOptions"
                  @change="onItemsPerPageChange"
                ></b-form-select>
              </b-form-group>
              <b-pagination
                v-model="pagination.page"
                :total-rows="pagination.total"
                :per-page="pagination.limit"
                @change="onChangePage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { StaffService } from '@/services/staff.service'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { Search as ListMa } from '@/services/customer-support/account'
  import { Search, GetMcIdFromMpos } from '@/services/customer-support/tpv'
  import { showMess } from '@/config/utils'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'merchant', label: 'Thông tin Merchant', class: 'text-center' },
    { key: 'sale', label: 'Nhân viên chăm sóc', class: 'task_class text-center' },
    { key: 'dateTransaction', label: 'Ngày giao dịch', class: 'text-center' },
    { key: 'tpv', label: 'TPV', class: 'text-center' },
    { key: 'tpvKpi', label: 'TPV KPI', class: 'text-center' },
    { key: 'typeTransaction', label: 'Loại giao dịch', class: 'text-center' },
    { key: 'serial', label: 'Thiết bị', class: 'text-center' },
    { key: 'typeMc', label: 'Nhóm merchant tính KPI', class: 'text-center' },
    // { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-left' }
  ]

  const optionTransactionType = [
    { id: 'MANUAL_PAYMENT', text: 'Thanh toán có hiện diện' },
    { id: 'ONLINE_PAYMENT', text: 'Thanh toán không hiện diện' },
    { id: 'INSTALLMENT', text: 'Thanh toán trả góp' },
    { id: 'BNPL', text: 'BNPL' },
    { id: 'MOTO', text: 'Moto' },
    { id: 'LENDING_NEXTLEND', text: 'Nextlend' },
    { id: 'OTHER', text: 'Other' },
  ]
  const optionTypeMc = [
    { id: 'NEW_MC', text: 'MC mới', variant: 'primary' },
    { id: 'OLD_MC_NEW_BRANCH', text: 'MC cũ CN mới', variant: 'warning' },
    { id: 'OLD_MC_REACTIVATED', text: 'MC cũ kích hoạt lại', variant: 'info' },
    { id: 'OTHER', text: 'MC không tính KPI', variant: 'danger' },
  ]
  export default {
    components: {},
    props: ['dataItem'],
    data() {
      return {
        id: '',
        filters: {
          merchantInfo: '',
          managerId: '',
          saleId: '',
          serial: '',
          typeTransaction: '',
          typeMc: '',
          dateTransactionFrom: '',
          dateTransactionTo: '',
          maId: '',
          fromDate: '',
          endDate: '',
          subTypeTransaction1: '',
          subTypeTransaction2: '',
        },
        maSearch: '',
        isLoading: true,
        selectAll: false,
        // dataDevices: [],
        dataTrans: [],
        dataType: [],
        listUser: [],
        userId: JSON.parse(localStorage.getItem('userData')).userId,
        Config,

        // config
        dataConfigService: [],
        sourceCreate: Config.sourceCreate,
        localeData: Config.localeData,
        ownershipType: [], // systemConfig.ownershipType,

        dataDevices: [
          { id: 'mpos', text: 'MPOS' },
          { id: 'mynextpay', text: 'My Nextpay' },
        ],
        optionTransactionType: optionTransactionType,
        optionTypeMc: optionTypeMc,
        totalCount: 0,
        fieldsTable,
        fields: fieldsTable,
        pagination: {
          queryString: '',
          sortField: 'createdDate',
          sortType: 'DESC',
          page: 1,
          total: 0,
          limit: 20,
        },
        totals: 0,
        totalTpv: 0,
        totalTpvKpi: 0,
        dataTable: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
        pageOptions: [
          { value: 20, text: '20/trang' },
          { value: 50, text: '50/trang' },
          { value: 100, text: '100/trang' },
          { value: 200, text: '200/trang' },
        ],
        maOptions: [],
        tLoadMa: undefined,
        maSettings: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              if (!txtSearch) {
                return success({
                  results: [],
                })
              }

              const querys = [
                `{textSearch} LIKE '''${txtSearch}''' OR {address} LIKE '''${txtSearch}'''`,
              ]
              if (this.tLoadMa) {
                clearTimeout(this.tLoadMa)
              }
              this.tLoadMa = setTimeout(() => {
                ListMa({
                  showFields: ['id', 'accountName', 'email'],
                  limit: 10,
                  page: 1,
                  queryString: querys.join(' AND '),
                  sort: {
                    direction: 'ASC',
                    properties: ['accountName'],
                  },
                })
                  .then(res => {
                    success({
                      results: res.data.listData.map(item => {
                        return {
                          id: item.id,
                          text: item.accountName || item.email,
                        }
                      }),
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
        subTypeTransaction1Bool: true,
        subTypeTransaction2Bool: true,
        optionSubTypeTransaction1: [],
        optionSubTypeTransaction2: [],
        optionSubType: [
          // 1
          {
            id: 'MANUAL_PAYMENT_BANK',
            text: 'Thanh toán thẻ',
            parent: 'MANUAL_PAYMENT',
          },
          {
            id: 'MANUAL_PAYMENT_NFC',
            text: 'Thanh toán NFC',
            parent: 'MANUAL_PAYMENT',
          },

          { id: 'MANUAL_PAYMENT_QR', text: 'QR code', parent: 'MANUAL_PAYMENT' },

          {
            id: 'ONLINE_PAYMENT_BANK',
            text: 'Thanh toán thẻ',
            parent: 'ONLINE_PAYMENT',
          },
          {
            id: 'ONLINE_PAYMENT_NFC',
            text: 'Thanh toán NFC',
            parent: 'ONLINE_PAYMENT',
          },
          {
            id: 'ONLINE_PAYMENT_QR',
            text: 'Qr code/khác',
            parent: 'ONLINE_PAYMENT',
          },
          {
            id: 'ONLINE_PAYMENT_PAYON',
            text: 'Tích hợp Payon',
            parent: 'ONLINE_PAYMENT',
          },

          // 2
          {
            id: 'MANUAL_PAYMENT_QR_VIETQR',
            text: 'VIETQR',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_QR',
          },
          {
            id: 'MANUAL_PAYMENT_QR_CREDIT',
            text: 'QR thẻ tín dụng',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_QR',
          },
          {
            id: 'MANUAL_PAYMENT_QR_OTHER',
            text: 'QR khác',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_QR',
          },

          {
            id: 'MANUAL_PAYMENT_NFC_AGS',
            text: 'NFC qua AGS',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_NFC',
          },
          {
            id: 'MANUAL_PAYMENT_NFC_BANK',
            text: 'NFC bằng thẻ',
            parent: 'MANUAL_PAYMENT',
            parent_sub1: 'MANUAL_PAYMENT_NFC',
          },
        ],
      }
    },
    async mounted() {
      if (this.dataPermission.includes('CNPS_CSS_MA_LIST')) {
        await this.getListStaffBySuperior()
        await this.searchMA()
        await this.buildQuery()
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.replace('/')
          })
      }
    },
    created() {
      this.filters.maId = this.$router.currentRoute.params.id
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      getStatusName() {
        return status => {
          const objStatus = this.listMcStatus.find(s => s.id === status)
          return objStatus ? objStatus.text : status
        }
      },
      getTypeTransaction() {
        return type => {
          const objType = this.optionTransactionType.find(s => s.id === type)
          return objType ? objType.text : type
        }
      },
      getTypeMc() {
        return type => {
          const objType = this.optionTypeMc.find(s => s.id === type)
          return objType ? objType.text : type
        }
      },
      getTypeMcVariant() {
        return type => {
          const objType = this.optionTypeMc.find(s => s.id === type)
          return objType ? objType.variant : type
        }
      },
    },
    methods: {
      transformDate() {
        console.log(this.dateRange)
        this.filters.fromDate = moment(this.dateRange.startDate)
          .startOf('day')
          // .add(7, 'hours')
          .valueOf()
        this.filters.toDate = moment(this.dateRange.endDate)
          .endOf('day')
          // .add(7, 'hours')
          .valueOf()
      },
      onItemsPerPageChange() {
        this.pagination.page = 1 // Reset về trang 1 khi thay đổi số mục mỗi trang
        this.refreshTable()
      },
      refreshTable() {
        this.buildQuery()
      },
      // nút bỏ lọc
      async clearSearch() {
        this.selectAll = false
        this.pagination.page = 1
        this.filters.merchantInfo = ''
        this.filters.managerStaffId = ''
        this.filters.staffId = ''
        this.filters.serial = ''
        this.filters.typeTransaction = ''
        this.filters.typeMc = ''
        this.filters.dateTransactionFrom = ''
        this.filters.dateTransactionTo = ''
        this.filters.maId = ''
        this.filters.fromDate = ''
        this.filters.toDate = ''
        this.filters.subTypeTransaction1 = ''
        this.filters.subTypeTransaction2 = ''
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.maOptions = []
        this.dataType = []
        this.dataKpi = []
        this.optionSubTypeTransaction1 = []
        this.optionSubTypeTransaction2 = []
        this.subTypeTransaction1Bool = true
        this.subTypeTransaction2Bool = true
        await this.buildQuery()
      },
      async buildQuery() {
        const conditions = []
        const conditionsMap = {}

        this.filters.managerStaffId &&
          this.filters.managerStaffId !== '0' &&
          (conditionsMap.managerId = this.filters.managerStaffId)
        this.filters.staffId &&
          this.filters.staffId !== '0' &&
          (conditionsMap.saleId = this.filters.staffId)
        this.filters.serial &&
          this.filters.serial !== '' &&
          (conditionsMap.serial = this.filters.serial)
        this.filters.typeTransaction &&
          this.filters.typeTransaction !== '0' &&
          (conditionsMap.typeTransaction = this.filters.typeTransaction)
        this.filters.subTypeTransaction1 &&
          this.filters.subTypeTransaction1 !== '0' &&
          (conditionsMap.subTypeTransaction1 = this.filters.subTypeTransaction1)
        this.filters.subTypeTransaction2 &&
          this.filters.subTypeTransaction2 !== '0' &&
          (conditionsMap.subTypeTransaction2 = this.filters.subTypeTransaction2)
        this.filters.typeMc &&
          this.filters.typeMc !== '0' &&
          (conditionsMap.typeMc = this.filters.typeMc)
        this.filters.maId &&
          this.filters.maId !== '0' &&
          (conditionsMap.merchantInfo = this.filters.maId)
        this.dateRange.startDate &&
          this.dateRange.startDate !== '0' &&
          (conditionsMap.dateTransactionFrom = moment(this.dateRange.startDate).format(
            'YYYY-MM-DD'
          ))
        this.dateRange.endDate &&
          this.dateRange.endDate !== '0' &&
          (conditionsMap.dateTransactionTo = moment(this.dateRange.endDate).format('YYYY-MM-DD'))

        this.pagination.queryString = conditions.join(' AND ')
        await this.loadData(conditionsMap)
      },

      formatDate(date, format = 'HH:mm, DD/MM/YYYY') {
        if (!date) return
        return moment(date).format(format)
      },
      async loadData(conditionsMap = {}) {
        try {
          this.isLoading = true
          const searchQuery = {
            limit: this.pagination.limit,
            page: this.pagination.page,
            ...conditionsMap,
            // sort: {
            //   direction: this.pagination.sortType,
            //   properties: [this.pagination.sortField],
            // }
          }
          // console.log(searchQuery)
          const res = await Search(searchQuery)
          // console.log(res)
          if (res.data.list) {
            this.dataTable = res.data.list
          } else {
            this.dataTable = []
          }
          this.pagination.total = res.data.count ?? 0
          this.totalCount = res.data.count ?? 0
          this.totalTpv = res.data.totalTpv ?? 0
          this.totalTpvKpi = res.data.totalTpvKpi ?? 0
        } catch (e) {
          showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        } finally {
          this.isLoading = false
        }
      },

      async submitForm(event) {
        event.preventDefault()
        this.pagination.page = 1
        // this.selectAll = false
        this.buildQuery()
      },
      // search MA
      async searchMA() {
        const res = await GetMcIdFromMpos(this.filters.maId)
        if (res.result && res.data) {
          this.maOptions = [{ id: this.filters.maId, text: res.data?.accountName }]
        }
      },
      // page
      onChangePage(pageIndex) {
        this.pagination.page = pageIndex
        this.buildQuery()
      },

      // Lấy danh sách nhân viên
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userId,
          })
          if (data.data.length > 0) {
            this.listUser = data.data.map(e => {
              return {
                id: e.userId,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.listUser.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      updateTypeOneTransaction() {
        this.subTypeTransaction2Bool = true
        this.subTypeTransaction1Bool = true
        this.filters.subTypeTransaction1 = ''
        this.filters.subTypeTransaction2 = ''

        if (!this.filters.typeTransaction || this.filters.typeTransaction === '0') {
          this.filters.subTypeTransaction2 = ''
          this.subTypeTransaction1Bool = true
          this.optionSubTypeTransaction1 = []
          this.optionSubTypeTransaction2 = []
        }
        if (this.filters.typeTransaction === 'ONLINE_PAYMENT') {
          this.subTypeTransaction1Bool = false
          this.optionSubTypeTransaction1 = this.optionSubType.filter(
            s => s.parent === 'ONLINE_PAYMENT'
          )
        }
        if (this.filters.typeTransaction === 'MANUAL_PAYMENT') {
          this.subTypeTransaction1Bool = false
          this.optionSubTypeTransaction1 = this.optionSubType.filter(
            s => s.parent === 'MANUAL_PAYMENT' && !s.parent_sub1
          )
        }
      },
      updateTypeTwoTransaction() {
        this.subTypeTransaction2Bool = true
        this.filters.subTypeTransaction2 = ''
        this.subTypeTransaction1Bool = false

        if (this.filters.subTypeTransaction1 === 'MANUAL_PAYMENT_QR') {
          this.subTypeTransaction2Bool = false
          this.optionSubTypeTransaction2 = this.optionSubType.filter(
            s => s.parent_sub1 === 'MANUAL_PAYMENT_QR'
          )
        } else if (this.filters.subTypeTransaction1 === 'MANUAL_PAYMENT_NFC') {
          this.subTypeTransaction2Bool = false
          this.optionSubTypeTransaction2 = this.optionSubType.filter(
            s => s.parent_sub1 === 'MANUAL_PAYMENT_NFC'
          )
        } else {
          this.optionSubTypeTransaction2 = []
        }
      },
    },
  }
</script>
<style scoped>
  .total_check {
    /* margin: 5px; */
    /* text-align: center; */
    display: flex;
    text-align: center;
  }

  .total_label {
    color: #8a9298;
    font-size: 14px;
  }

  .total_field {
    font-size: 20px;
  }
</style>
<style>
  .td_class {
    min-width: 150px;
    max-width: 200px;
  }

  .time_class {
    min-width: 100px;
    max-width: 200px;
  }

  .nowrap {
    white-space: nowrap;
  }

  .tooltip-class .tooltip-inner {
    background-color: rgb(253, 253, 253);
    color: #319db5;
    text-align: left;
    max-height: 150px;
    max-width: 200px;
    overflow-y: auto;
    border: 1px solid;
  }

  .title_h {
    font-size: 20px;
    font-weight: 400;
    line-height: 23.44px;
    text-align: left;
  }
</style>
